module.exports = __webpack_public_path__ + "img/bg-quem-somos.10b2c2bc.jpg";